<script>
import { mapState, mapActions } from "vuex";
import PreloaderTable from "@/components/_Shared/PreloaderTable";
import dateMixin from "@/mixins/dateMixin";
import numberMixin from "@/mixins/numberMixin";
import orderMixin from "@/mixins/orderMixin";
import moment from "@/utils/moment";

import DataTableTitle from "@/components/_Shared/DataTable/Title";

import UpdateCoupon from "./Update";
import CreateCoupon from "./Create";

export default {
  title: "Cupons do Profissional",
  mixins: [dateMixin, numberMixin, orderMixin],
  components: {
    PreloaderTable,
    DataTableTitle,
    UpdateCoupon,
    CreateCoupon
  },
  props: {
    professional: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      expanded: [],
      updateCouponDialog: false,
      createCouponDialog: false,
      selectedCoupon: {
        max_usage: { total: 0 },
        expires_at: moment().toISOString()
      }
    };
  },
  filters: {
    state(val) {
      return moment(val) < moment() ? "expirado" : "ativo";
    }
  },
  computed: {
    ...mapState("professionalCoupons", [
      "headers",
      "items",
      "totalItems",
      "options",
      "loader",
      "footerProps"
    ]),
    options: {
      get() {
        return this.$store.state.professionalCoupons.options;
      },
      set(value) {
        this.$store.dispatch("professionalCoupons/setOptions", value);
      }
    }
  },
  methods: {
    ...mapActions("professionalCoupons", ["getItems", "setProfessional"]),
    getItemStateColor(item) {
      const expired = moment(item.expires_at) < moment();
      if (expired) return "error";
      return "success";
    },
    selectCoupon(coupon) {
      this.selectedCoupon = coupon;
      this.updateCouponDialog = true;
    },
    openCreateCupomDialog() {
      this.createCouponDialog = true;
    }
  },
  async mounted() {
    this.setProfessional(this.professional);
    await this.getItems();
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true
    }
  }
};
</script>

<template>
  <div>
    <UpdateCoupon
      :dialog="updateCouponDialog"
      v-bind:coupon="selectedCoupon"
      @close="updateCouponDialog = false"
    />
    <CreateCoupon
      :dialog="createCouponDialog"
      @close="createCouponDialog = false"
    />

    <data-table-title
      icon="bookmark"
      title="Cupons"
      :button-text="this.items.length > 0 ? null : 'Criar novo cupom'"
      :buttonTextAction="openCreateCupomDialog"
      :hasSearchBox="false"
    />

    <v-divider></v-divider>

    <v-layout column>
      <v-data-table
        :headers="headers"
        :items="items"
        :show-expand="true"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="footerProps"
        :loading="loader"
        :expanded.sync="expanded"
      >
        <template v-slot:item="{ item, expand, isExpanded }">
          <tr>
            <td @click="expand(!isExpanded)">
              <v-icon v-if="isExpanded" small color="gray">mdi-menu-up</v-icon>
              <v-icon v-else small color="gray">mdi-menu-down</v-icon>
            </td>
            <td>{{ item.name }}</td>
            <td>
              <v-chip small :color="getItemStateColor(item)">{{
                item.expires_at | state
              }}</v-chip>
            </td>
            <td>
              <v-chip small outlined color="primary">{{
                item.expires_at | formatDate("DD/MM/Y")
              }}</v-chip>
            </td>
            <td>
              <v-chip small outlined color="primary">{{
                item.created_at | formatDate("DD/MM/Y")
              }}</v-chip>
            </td>
            <td>
              <v-chip
                v-if="item.value_type === 'VALUE'"
                small
                color="primary"
                >{{ item.value | intToCurrency }}</v-chip
              >
              <v-chip v-else small color="primary">{{ item.value }}%</v-chip>
            </td>
            <td>
              <v-chip small color="primary">{{ item.max_usage.total }}</v-chip>
            </td>
            <td>0</td>
            <td>
              <v-icon small class="mr-2" @click="selectCoupon(item)">
                mdi-pencil
              </v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <div :key="order.id" v-for="(order, orderIndex) in item.orders">
              <p>
                <strong> {{ orderIndex }} </strong>:
                <a
                  v-bind:href="'https://admin.donamaid.com/pedido/' + order.id"
                >
                  https://admin.donamaid.com/pedido/{{ order.id }}
                </a>
                -
                <strong> status {{ order.status | getStatusName }} </strong>
              </p>
            </div>
          </td>
        </template>
      </v-data-table>
    </v-layout>
  </div>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Coupons/Index.vue